import { render } from "./PlayCircleIcon.vue?vue&type=template&id=4e96c242&ts=true"
import script from "./PlayCircleIcon.vue?vue&type=script&lang=ts"
export * from "./PlayCircleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__